export default __webpack_public_path__ + "static/media/Website.9d1809ab.svg";